import { Typography, Box } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';

interface IProps {
	title: string;
}

const PaymentHeader = ({ title }: IProps) => (
	<div>
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				marginTop: '30px',
				marginBottom: '30px',
			}}
		>
			<LockOutlined
				sx={(theme) => ({
					marginRight: theme.spacing(1),
					marginBottom: theme.spacing(1),
					color: theme.palette.primary.main,
				})}
			/>
			<Typography variant='h5' component='h5' gutterBottom sx={{ textAlign: 'center', color: 'primary.main' }}>
				{title}
			</Typography>
		</Box>
	</div>
);

export default PaymentHeader;
